var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-drawer",
    {
      attrs: {
        title: "资产卡片详情：" + (_vm.card.assetName || ""),
        width: 960,
        visible: _vm.visible,
        "body-style": { paddingBottom: "24px" },
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _c(
            "a-descriptions",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: {
                title: "基本信息",
                column: 3,
                size: "small",
                bordered: "",
              },
            },
            [
              _c("a-descriptions-item", { attrs: { label: "资产编码" } }, [
                _vm._v(_vm._s(_vm.card.assetCode || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "资产名称" } }, [
                _vm._v(_vm._s(_vm.card.assetName || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "规格型号" } }, [
                _vm._v(_vm._s(_vm.card.assetModel || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "资产类别" } }, [
                _vm._v(_vm._s(_vm.card.categoryName || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "折旧政策" } }, [
                _vm._v(_vm._s(_vm.card.policyName || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "状态" } }, [
                _vm._v(_vm._s(_vm.card.status || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "资产原值" } }, [
                _vm._v(_vm._s(_vm.fmt(_vm.card.originalValue))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "月折旧额" } }, [
                _vm._v(_vm._s(_vm.fmt(_vm.card.monthlyDepreciation))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "残值率" } }, [
                _vm._v(
                  _vm._s(
                    _vm.card.residualRate == null
                      ? "-"
                      : (Number(_vm.card.residualRate) * 100).toFixed(2) + "%"
                  )
                ),
              ]),
              _c("a-descriptions-item", { attrs: { label: "使用年限(月)" } }, [
                _vm._v(
                  _vm._s(
                    _vm.card.serviceLife == null ? "-" : _vm.card.serviceLife
                  )
                ),
              ]),
              _c("a-descriptions-item", { attrs: { label: "已提月数" } }, [
                _vm._v(
                  _vm._s(_vm.card.depMonths == null ? "-" : _vm.card.depMonths)
                ),
              ]),
              _c("a-descriptions-item", { attrs: { label: "启用日期" } }, [
                _vm._v(_vm._s(_vm.card.startDate || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "累计折旧" } }, [
                _vm._v(_vm._s(_vm.fmt(_vm.card.accumulatedDepreciation))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "减值准备" } }, [
                _vm._v(_vm._s(_vm.fmt(_vm.card.impairmentAmount))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "净值" } }, [
                _vm._v(_vm._s(_vm.fmt(_vm.card.netValue))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "期初累计折旧" } }, [
                _vm._v(_vm._s(_vm.fmt(_vm.card.initialAccumDep))),
              ]),
              _c("a-descriptions-item", { attrs: { label: "存放地点" } }, [
                _vm._v(_vm._s(_vm.card.location || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "保管人" } }, [
                _vm._v(_vm._s(_vm.card.responsiblePerson || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "折旧费用科目" } }, [
                _vm._v(_vm._s(_vm.card.depExpenseCode || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "税法年限(月)" } }, [
                _vm._v(
                  _vm._s(
                    _vm.card.taxLifeMonths == null
                      ? "-"
                      : _vm.card.taxLifeMonths
                  )
                ),
              ]),
              _c("a-descriptions-item", { attrs: { label: "一次性扣除" } }, [
                _vm._v(_vm._s(_vm.card.taxOneOff === "1" ? "是" : "否")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "转固单号" } }, [
                _vm._v(_vm._s(_vm.card.transBillNo || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "来源单号" } }, [
                _vm._v(_vm._s(_vm.card.sourceBillNo || "-")),
              ]),
              _c("a-descriptions-item", { attrs: { label: "备注", span: 3 } }, [
                _vm._v(_vm._s(_vm.card.remark || "-")),
              ]),
            ],
            1
          ),
          _c(
            "a-tabs",
            {
              on: { change: _vm.onTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "a-tab-pane",
                { key: "dep", attrs: { tab: "折旧明细" } },
                [
                  _c("a-table", {
                    attrs: {
                      bordered: "",
                      size: "small",
                      rowKey: "id",
                      columns: _vm.depColumns,
                      dataSource: _vm.depRows,
                      loading: _vm.depLoading,
                      pagination: _vm.depPagination,
                    },
                    on: { change: _vm.onDepPageChange },
                  }),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "change", attrs: { tab: "变动历史" } },
                [
                  _c("a-table", {
                    attrs: {
                      bordered: "",
                      size: "small",
                      rowKey: "id",
                      columns: _vm.changeColumns,
                      dataSource: _vm.changeRows,
                      loading: _vm.changeLoading,
                      pagination: _vm.changePagination,
                    },
                    on: { change: _vm.onChangePageChange },
                  }),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "repair", attrs: { tab: "维修记录" } },
                [
                  _c("a-table", {
                    attrs: {
                      bordered: "",
                      size: "small",
                      rowKey: "id",
                      columns: _vm.repairColumns,
                      dataSource: _vm.repairRows,
                      loading: _vm.repairLoading,
                      pagination: _vm.repairPagination,
                    },
                    on: { change: _vm.onRepairPageChange },
                  }),
                ],
                1
              ),
              _c(
                "a-tab-pane",
                { key: "attachment", attrs: { tab: "附件" } },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "12px" } },
                    [
                      _c(
                        "a-select",
                        {
                          staticStyle: {
                            width: "120px",
                            "margin-right": "8px",
                          },
                          model: {
                            value: _vm.uploadType,
                            callback: function ($$v) {
                              _vm.uploadType = $$v
                            },
                            expression: "uploadType",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "照片" } }, [
                            _vm._v("照片"),
                          ]),
                          _c("a-select-option", { attrs: { value: "铭牌" } }, [
                            _vm._v("铭牌"),
                          ]),
                          _c(
                            "a-select-option",
                            { attrs: { value: "存放位置" } },
                            [_vm._v("存放位置")]
                          ),
                          _c("a-select-option", { attrs: { value: "其他" } }, [
                            _vm._v("其他"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "a-upload",
                        {
                          attrs: {
                            showUploadList: false,
                            beforeUpload: _vm.beforeUpload,
                            accept: ".jpg,.jpeg,.png,.gif,.bmp,.pdf",
                          },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "upload",
                                loading: _vm.uploading,
                              },
                            },
                            [_vm._v("上传附件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-table", {
                    attrs: {
                      bordered: "",
                      size: "small",
                      rowKey: "id",
                      columns: _vm.attachColumns,
                      dataSource: _vm.attachRows,
                      loading: _vm.attachLoading,
                      pagination: false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "attachAction",
                        fn: function (text, record) {
                          return [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.previewAttachment(record)
                                  },
                                },
                              },
                              [_vm._v("预览")]
                            ),
                            _c("a-divider", { attrs: { type: "vertical" } }),
                            _c(
                              "a-popconfirm",
                              {
                                attrs: { title: "确认删除该附件?" },
                                on: {
                                  confirm: () => _vm.deleteAttachment(record),
                                },
                              },
                              [
                                _c("a", { staticStyle: { color: "red" } }, [
                                  _vm._v("删除"),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }